import React from "react";
import MainCalculatorsList from "./MainCalculators";
import SharedHelmet from ".././Helmet";
import RelatedLinks from "../RelatedLinks";
import { FirstAds, SecondAds , MobileUnderCalAds } from "../../Ads";
import imageUrl from "../../../images/StudyCalculatorImg.webp";
import SharedGradeUk from "./SharedGradeUk";
const TITLE = "Konversi IPK Universitas ke Sistem Inggris - Sarjana dan Magister";
const DESCRIPTION =
  "Konversi IPK Anda ke sistem penilaian Inggris dengan mudah dan akurat. Pelajari cara mengkonversi nilai sarjana dan magister dari sistem universitas ke sistem Inggris menggunakan alat yang berguna ini.";
const KEYWORDS =
  "konversi IPK universitas, konversi ke sistem Inggris, konversi nilai sarjana, konversi nilai magister, IPK universitas, sistem Inggris";
const OG_URL = "https://do-calculate.com/calculator/id/gradetouk";
function GradeToUk() {
  return (
    <div>
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div
            className="bg-success text-white text-center"
            style={{ height: "50px" }}
          >
            <h1 style={{ fontSize: "17px" }}>{TITLE}</h1>
          </div>
          <div className="border border-light">
            <div className="row">
              <div>
                <p>
                  Konversi IPK Anda (persentase atau IPK) ke sistem penilaian Inggris dengan mudah dan akurat. Pelajari cara mengkonversi nilai sarjana dan magister dari sistem universitas ke sistem Inggris menggunakan alat yang berguna ini.
                </p>
              </div>
              <br />
            </div>
            <hr />
             <MobileUnderCalAds />
            <div className="row">
              <div className="col">
                <SharedGradeUk />
              </div>
            </div>
            <hr />
            <div className="row">
              <RelatedLinks />
              <hr />
            </div>
          </div>
        </div>
        <div className="col">
          <SecondAds />
          <br />
          <MainCalculatorsList></MainCalculatorsList>
          <br />
        </div>
      </div>
      <div className="row" style={{ height: "auto" }}>
        <div className="col-12 col-md-8">
          <div className="info-sections-container">
            <div className="info-section">
              <div className="info-section-header">{TITLE} </div>
              <div className="info-section-body">
                <div>
                  <u>
                    <h2 style={{ fontSize: "16px" }}>
                      {" "}
                      Sistem Klasifikasi Studi Universitas di Inggris
                    </h2>
                  </u>
                  <p>
                    Di Inggris, universitas menawarkan dua jenis gelar sarjana: gelar kehormatan dan gelar biasa.
                    <br />
                    Gelar kehormatan adalah yang paling umum. Anda dapat menyelesaikan gelar kehormatan dengan nilai atau skor yang berbeda. Berdasarkan nilai Anda, Anda dapat memperoleh 4 jenis gelar kehormatan saat lulus:
                    <br/>                    <b>Gelar Kehormatan Kelas Satu (First-Class Honours atau 1st):</b>
                    Setara dengan nilai A. Anda harus menyelesaikan studi dengan nilai keseluruhan 70% atau lebih tinggi. Ini adalah prestasi akademik yang luar biasa dan merupakan keuntungan saat melamar gelar magister atau pekerjaan.
                    <br />
                    <b>
                      Gelar Kehormatan Kelas Dua Atas (Upper Second-Class Honours atau 2:1):
                    </b>
                    Setara dengan nilai B. Anda memerlukan nilai keseluruhan antara 60-69% untuk mendapatkannya. Jenis gelar ini adalah persyaratan umum saat melamar program magister.
                    <br />
                    <b>
                      Gelar Kehormatan Kelas Dua Bawah (Lower Second-Class Honours atau 2:2):
                    </b>
                    Setara dengan nilai C. Untuk mendapatkan gelar ini, Anda memerlukan nilai antara 50-59%. Ini tidak setenar gelar kehormatan kelas satu atau 2:1 tetapi diterima oleh beberapa program magister.
                    <br />
                    <b>Gelar Kehormatan Kelas Tiga (Third-Class Honours atau 3rd).</b>
                    Setara dengan nilai D. Jenis gelar ini diberikan kepada siswa yang menyelesaikan studi dengan nilai keseluruhan antara 40-49%. Meskipun masih lulus, akan sangat sulit untuk bersaing dengan siswa lain saat melamar program magister.
                    <br/>                  </p>
                  <div className="p-3 mb-2 bg-warning text-dark">
                    Jika nilai keseluruhan Anda di bawah 40%, maka Anda gagal, dan itu setara dengan menerima nilai F. Gelar biasa kurang umum tetapi ditawarkan sebagai gelar terpisah oleh beberapa universitas. Mereka juga dapat diberikan kepada siswa yang menyelesaikan gelar kehormatan, tetapi tanpa memenuhi persyaratan minimum untuk salah satu sertifikat kehormatan.
                  </div>
                </div>
                <hr />
                <div>
                  <u>
                    <h2 style={{ fontSize: "16px" }}>
                      {" "}
                      Sistem Klasifikasi Pascasarjana di Inggris
                    </h2>
                  </u>
                  Sistem klasifikasi pascasarjana untuk gelar magister mirip dengan sistem kehormatan, tetapi berbeda dalam beberapa hal. Batas minimum kelulusan adalah 50% bukan 40%. Sertifikat lengkap adalah sebagai berikut:
                  <ul>
                    <li>Distinction: 70-100%</li>
                    <li>Merit: 60-69%</li>
                    <li>Pass: 50-59%</li>
                    <li>Fail: Kurang dari 50%</li>
                  </ul>
                </div>
                <hr />
                <div>
                  <u>
                    <h2 style={{ fontSize: "16px" }}>
                      {" "}
                      Konversi Nilai Inggris ke IPK (GPA)
                    </h2>
                  </u>
                  Universitas dan perguruan tinggi Amerika biasanya menggunakan IPK (GPA) untuk mengevaluasi kinerja keseluruhan siswa. IPK dihitung menggunakan nilai Anda dan jumlah SKS untuk setiap mata kuliah yang Anda ambil. Konversi perkiraan nilai Inggris ke IPK (GPA) adalah sebagai berikut:
                  <table >
                    <thead>
                      <tr className="bmi-header">
                        <th>Nilai dalam Sistem Inggris</th>
                        <th>IPK (GPA)</th>
                        </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>First-Class Honours (1st)</td>
                        <td>4.0</td>
                      </tr>
                      <tr>
                        <td>Upper Second-Class Honours (2:1)</td>
                        <td>3.3 - 3.9</td>
                      </tr>
                      <tr>
                        <td>Lower Second-Class Honours (2:2)</td>
                        <td>2.7 - 3.2</td>
                      </tr>
                      <tr>
                        <td>Third-Class Honours (3rd)</td>
                        <td>2.0 - 2.6</td>
                      </tr>
                      <tr>
                        <td>Pass</td>
                        <td>1.0 - 1.9</td>
                      </tr>
                      <tr>
                        <td>Fail</td>
                        <td>0.0</td>
                      </tr>
                    </tbody>
                  </table>
                  <div className="p-3 mb-2 bg-warning text-dark">
                    Kurang dari 40% = 1.0-1.9 – ini belum tentu gagal; di beberapa universitas, ini mungkin setara dengan memperoleh gelar biasa di Inggris.
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
         </div>
</div>
  );
}
export default GradeToUk;